import React from 'react';

import { referralFooterURL } from '../Config';
import KeywordSelector from './keywords/KeywordSelector';
import TypingSwitch from './typing-switch/TypingSwitch';
import ScrollButton from './messenger/ScrollButton';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brand_name: props.brand_name,
      keywords: props.keywords,
      branding: props.branding,
      typing: props.typing,
    };
    this.ee = props.ee;
  }

  render() {
    const { brand_name, keywords, branding, typing } = this.props;

    return (
      <footer id="hu-footer">
        <KeywordSelector
          keywords={keywords}
          ee={this.ee}
        />
        {/* <ScrollButton
          ee={this.ee}
          //clickHandler={this.onScrollButtonClick.bind(this)}
        /> */}
        <TypingSwitch
          typing={typing}
          ee={this.ee}
        />
        { branding &&
          <div className="hu-mobile-powered-by">
            <p className={`powered-by-text hu-a-center hu-color_contrast hu-s-12`}>
              Powered by <a className="hu-border-color_contrast" target="_blank" href={referralFooterURL}><b>Landbot.io</b></a>
            </p>
          </div>
        }
      </footer>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./app/js/components/Footer.js